import React from 'react';
import Icon from '../../../components/AppIcon';

const EventLegend = () => {
  const legendItems = [
    {
      icon: 'Calendar',
      label: 'Appointment',
      color: 'bg-blue-100 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400'
    },
    {
      icon: 'Package',
      label: 'Delivery',
      color: 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-600 dark:text-yellow-400'
    },
    {
      icon: 'AlertCircle',
      label: 'Overdue',
      color: 'bg-red-100 dark:bg-red-900/20 text-red-600 dark:text-red-400'
    },
    {
      icon: 'Clock',
      label: 'Within 24h',
      color: 'bg-green-100 dark:bg-green-900/20 text-green-600 dark:text-green-400'
    }
  ];

  return (
    <div className="flex flex-wrap items-center gap-4 mb-6 pb-4 border-b border-border">
      <span className="text-sm font-medium text-muted-foreground">Legend:</span>
      {legendItems?.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          <div className={`w-8 h-8 rounded-lg ${item?.color} flex items-center justify-center`}>
            <Icon name={item?.icon} size={14} />
          </div>
          <span className="text-sm text-foreground">{item?.label}</span>
        </div>
      ))}
    </div>
  );
};

export default EventLegend;